// Module
var code = "<template> <div class=\"popup-category-section\"> <div class=\"popup-category-left\"></div> <div class=\"popup-category-title\" title=\"${label}\">${label}</div> </div> </template> ";
// Exports
export default code;